const initialState = {
    error: ''
};

export default function globalError(state = initialState, action = {}) {
    if(action.type.includes('_FAIL')) {
        return {error: action.error};
    }

    if(action.type == 'REMOVE_GLOBAL_ERROR') {
        return {error: ''};
    }

    return state;
}




// WEBPACK FOOTER //
// ./app/reducers/globalError.js